import InfoIcon from './infoIcon';
export default InfoIcon;